import { ApiClient } from './api-client-class';

import { config } from '../config';

export const apiClient = new ApiClient(config.baseURL);
